import {
  defaultClient as apolloClient,
} from '@/plugins/vue-apollo';

import {
  DOWNLOAD_TRANSACTION_LIST_PDF,
  DOWNLOAD_TRANSACTION_IN_PDF,
  REMOVE_PDF_LINK,
} from '@/graphql/transactions.gql';

export default {
  namespaced: true,
  state: {
    generatePdfTransaction: null,
    removedPdfLink: null,
  },
  mutations: {
    REMVOED_PDF_LINK(state, payload) {
      state.removedPdfLink = payload;
    },
    SET_GENERATED_PDF_TRANSACTION(state, payload) {
      state.generatePdfTransaction = payload;
    },
  },
  actions: {
    async generatePdfTransactions({ commit }, payload) {
      await apolloClient
        .query({
          query: DOWNLOAD_TRANSACTION_LIST_PDF,
          variables: {
            recordStatus: 1,
            ...payload,
          },
          fetchPolicy: 'no-cache',
        }).then((generatePdfTransactionsData) => {
          commit('SET_GENERATED_PDF_TRANSACTION', generatePdfTransactionsData.data.generatePdfTransactions);
        }).catch((generatePdfTransactionsErr) => {
          console.log(generatePdfTransactionsErr);
        });
    },

    async downloadTransactionInPDF({ _commit }, payload) {
      await apolloClient
        .query({
          query: DOWNLOAD_TRANSACTION_IN_PDF,
          variables: payload,
          context: {
            headers: { operationname: 'downloadTransactionInPDF' },
          },
          fetchPolicy: 'no-cache',
        }).then(() => {
          // Request send to generate pdf file
        }).catch((downloadTransactionInPDFerr) => {
          console.log(downloadTransactionInPDFerr);
        });
    },

    async generateLinkAndDonwloadPdf({ _commit }, payload) {
      const BUCKET_NAME = process.env.VUE_APP_PDF_GENERATED_TRANSACTION;
      const IAM_USER_KEY = process.env.VUE_APP_AWS_IAM_USER_KEY;
      const IAM_USER_SECRET = process.env.VUE_APP_AWS_IAM_USER_SECRET;

      const s3bucket = new AWS.S3({
        accessKeyId: IAM_USER_KEY,
        secretAccessKey: IAM_USER_SECRET,
        Bucket: BUCKET_NAME,
      });

      const receipt = payload.pdfLink;
      const keyPart = receipt.split('.com/');
      const key = keyPart[1];
      const replaced = key.replace('%20', ' ');
      const params = {
        Bucket: BUCKET_NAME,
        Key: replaced,
        Expires: 240,
      };
      // Get signed URL for downalod pdf
      const url = s3bucket.getSignedUrl('getObject', params);
      // Download givne pdf
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.target = '_blank';
      anchor.click();
    },

    async removeDownloadedPdfLink({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: REMOVE_PDF_LINK,
          variables: payload,
        })
        .then((removeDownloadedPdfLinkData) => {
          commit('REMVOED_PDF_LINK', removeDownloadedPdfLinkData.data.removeDownloadedPdfLink);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((removeDownloadedPdfLinkErr) => {
          console.log(removeDownloadedPdfLinkErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

  },
  getters: {
    generatePdfTransaction: state => state.generatePdfTransaction,
    removedPdfLink: state => state.removedPdfLink,
  },
};
